// tourSteps.js

export const useDashboardTourLogic = ({handleTabMainChange}) => {
  
 const tourSteps = [
  {
    selector: '[data-tour="time-clock-section"]',
    content: 'This is the Time Clock. You and your team can easily Clock-In & Out for accurate time tracking.',       
    action: (node) => {
      if(node){
        node.focus();
      }            
    }
  },
  {
    
    selector: '[data-tour="dashboard-tasks-section"]',
    content: "These are your assigned tasks. See what's been assigned to you & your team members.",
    action: (node) => {      
      handleTabMainChange("1");
      if(node){
        node.focus();
      } 
    },
    highlightedSelectors: ['[data-tour="tasks-list"]']
  },
  {
    selector: '[data-tour="dashboard-todo-section"]',
    content: 'Here is your To-Do list. Keep track of your tasks in one place.',
    action: (node) => {      
      handleTabMainChange("2");
      if(node){
        node.focus();
      } 
    },
    highlightedSelectors: ['[data-tour="todo-list"]']
  },
]

return {tourSteps};
};
